import { render, staticRenderFns } from "./Festival2.vue?vue&type=template&id=52914058&scoped=true&"
import script from "./Festival2.vue?vue&type=script&lang=js&"
export * from "./Festival2.vue?vue&type=script&lang=js&"
import style0 from "./Festival2.vue?vue&type=style&index=0&id=52914058&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52914058",
  null
  
)

export default component.exports